export default __webpack_public_path__ + "static/eu-f059a3596b4a670fe086263e961d637c.svg";